"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ProjectImage_1 = __importDefault(require("~/components/UI/Image/ProjectImage"));
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const utils_1 = require("~/utils/utils");
const selectors_1 = require("~/store/selectors");
const assets_1 = require("~/assets");
const routes_1 = require("~/consts/routes");
const DeletionConfirmationModal_1 = __importDefault(require("~/components/WidgetsManager/RecommendedFastenersWidget/DeletionConfirmationModal"));
const UI_1 = require("~/components/UI");
const types_1 = require("~/store/types");
const DuplicateProjectModal_1 = __importDefault(require("~/components/ProjectManagement/DuplicateProjectModal"));
const events_1 = require("~/utils/events");
const consts_1 = require("~/store/account/consts");
const ProjectItem_module_scss_1 = __importDefault(require("./ProjectItem.module.scss"));
function ProjectItem({ project, selected, deletable, onSelect, onDelete, onOpen, onDuplicate }) {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)('project');
    const navigate = (0, react_router_dom_1.useNavigate)();
    const currentUserRole = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserRole);
    const currentProjectId = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProjectId);
    const isCurrentProject = project.id === currentProjectId;
    const selectOptionHandler = (key) => {
        switch (key) {
            case 'open':
                onOpen({ projectId: project.id, optionHandlerMatch: true });
                navigate(routes_1.ROUTE_PROJECT.replace(':projectId', String(project.id)));
                break;
            case 'edit':
                navigate(routes_1.ROUTE_EDIT_PROJECT.replace(':projectId', String(project.id)));
                break;
            case 'duplicate':
                (0, events_1.showModal)(react_1.default.createElement(DuplicateProjectModal_1.default, { project: project, onDuplicate: onDuplicate }));
                break;
            case 'delete':
                (0, events_1.showModal)(react_1.default.createElement(DeletionConfirmationModal_1.default, { middleOfTitle: `${project.name} `, endOfTitle: t('projects-modal.project'), onSubmit: () => {
                        onDelete(project.id);
                        if (isCurrentProject) {
                            navigate(routes_1.ROUTE_HOME);
                        }
                    } }));
                break;
            default:
        }
    };
    const getOptions = () => {
        const options = {
            open: t('projects-modal.open'),
            edit: t('projects-modal.edit'),
            duplicate: t('projects-modal.duplicate'),
            delete: t('projects-modal.delete'),
        };
        const isCustomer = currentUserRole === consts_1.UserRoles.customer;
        const completedByAdmin = currentUserRole === consts_1.UserRoles.distributor && project.completedBy === consts_1.UserRoles.admin;
        const completedByDistributor = currentUserRole === consts_1.UserRoles.admin && project.completedBy === consts_1.UserRoles.distributor;
        const projectCompleted = project.status === types_1.PROJECT_STATUS.ORDER_ENTERED;
        if (!deletable || project.shared || projectCompleted) {
            delete options.delete;
        }
        if (projectCompleted && (isCustomer || completedByAdmin || completedByDistributor)) {
            delete options.edit;
        }
        return options;
    };
    const quote = (_a = project.quotes) === null || _a === void 0 ? void 0 : _a.at(0);
    return (react_1.default.createElement("div", { className: ProjectItem_module_scss_1.default.item, "data-selected": selected, onClick: () => onSelect(project) },
        react_1.default.createElement(ProjectImage_1.default, { project: project, currentProjectId: currentProjectId, defaultImg: assets_1.svgPlaceholdersExtrusionsSmallIcon }),
        react_1.default.createElement("div", { className: ProjectItem_module_scss_1.default.content },
            react_1.default.createElement("div", { className: ProjectItem_module_scss_1.default.row },
                react_1.default.createElement("span", { className: ProjectItem_module_scss_1.default.title }, project.name),
                react_1.default.createElement(UI_1.Options, { options: getOptions(), onClick: selectOptionHandler, placement: "left-start" })),
            react_1.default.createElement("div", { className: ProjectItem_module_scss_1.default.row },
                react_1.default.createElement("span", { className: ProjectItem_module_scss_1.default.status }, project.status),
                react_1.default.createElement("div", { className: ProjectItem_module_scss_1.default.label },
                    "Last Modified: ",
                    (0, utils_1.formatTimeToRelative)(project.updatedAt))),
            react_1.default.createElement("div", { className: ProjectItem_module_scss_1.default.row },
                react_1.default.createElement("div", { className: `${ProjectItem_module_scss_1.default.label} ${ProjectItem_module_scss_1.default['reference-number']}` },
                    "Reference Number: ",
                    project.referenceNumber,
                    (quote === null || quote === void 0 ? void 0 : quote.revisionNumber) ? `-${quote.revisionNumber}` : '')))));
}
exports.default = ProjectItem;
